export const ONB_PARTNER_DATA_FORM_TRANSLATION_KEYS = {
  container: {
    button: {
      apply: 'onb-partnereditor-container-button-apply',
      saveAsDraft: 'onb-partnereditor-container-button-save-as-draft',
      cancel: 'onb-partnereditor-container-button-cancel',
      close: 'onb-partnereditor-container-button-close',
      edit: 'onb-partnereditor-container-button-edit',
      inactivate: 'onb-partnereditor-container-button-inactivate',
    },
    tips: {
      inactivate: {
        possible: 'onb-partnereditor-container-tips-inactivate-possible',
        notPossible: 'onb-partnereditor-container-tips-inactivate-not-possible',
      },
    },
  },
  dialog: {
    closeConfirm: {
      title: 'onb-partnereditor-dialog-closeconfirm-title',
      content: 'onb-partnereditor-dialog-closeconfirm-content',
      confirmBtn: 'onb-partnereditor-dialog-closeconfirm-confirm-btn',
      rejectBtn: 'onb-partnereditor-dialog-closeconfirm-reject-btn',
    },
    approveRequest: {
      title: 'onb-partnereditor-dialog-approverequest-title',
      content: 'onb-partnereditor-dialog-approverequest-content',
      confirmBtn: 'onb-partnereditor-dialog-approverequest-confirm-btn',
      rejectBtn: 'onb-partnereditor-dialog-approverequest-reject-btn',
    },
    rejectRequest: {
      title: 'onb-partnereditor-dialog-rejectrequest-title',
      content: 'onb-partnereditor-dialog-rejectrequest-content',
      confirmBtn: 'onb-partnereditor-dialog-rejectrequest-confirm-btn',
      rejectBtn: 'onb-partnereditor-dialog-rejectrequest-reject-btn',
    },
    removeRequest: {
      title: 'onb-partnereditor-dialog-removerequest-title',
      content: 'onb-partnereditor-dialog-removerequest-content',
      confirmBtn: 'onb-partnereditor-dialog-removerequest-confirm-btn',
      rejectBtn: 'onb-partnereditor-dialog-removerequest-reject-btn',
    },
    mandatoryAttachments: {
      title: 'onb-partnereditor-dialog-mandatoryattachments-title',
      confirmBtn: 'onb-partnereditor-dialog-mandatoryattachments-confirm-btn',
      rejectBtn: 'onb-partnereditor-dialog-mandatoryattachments-reject-btn',
    },
    inactivatePartner: {
      title: 'onb-partnereditor-dialog-inactivatepartner-title',
      content: 'onb-partnereditor-dialog-removerequest-content',
      confirmBtn: 'onb-partnereditor-dialog-inactivatepartner-confirm-btn',
      rejectBtn: 'onb-partnereditor-dialog-inactivatepartner-reject-btn',
    },
    rejectInactivationPartner: {
      title: 'onb-partnereditor-dialog-rejectinactivationpartner-title',
      content: 'onb-partnereditor-dialog-rejectinactivationpartner-content',
      confirmBtn: 'onb-partnereditor-dialog-rejectinactivationpartner-confirm-btn',
      rejectBtn: 'onb-partnereditor-dialog-rejectinactivationpartner-reject-btn',
    },
  },
  validation: {
    attachments: 'onb-partnereditor-validation-attachments',
  },
  inactivePartnerPanel: {
    content: 'partnereditor-inactivepartnerpanel-content',
    button: 'partnereditor-inactivepartnerpanel-button',
  },
  workflowStatus: {
    label: 'partnereditor-workflowstatus-label',
    button: {
      approve: 'partnereditor-workflowstatus-button-approve',
      remove: 'partnereditor-workflowstatus-button-remove',
      reject: 'partnereditor-workflowstatus-button-reject',
    },
  },
  other: {
    menuStatus: 'onb-partnereditor-other-menu-status',
    menuInactive: 'onb-partnereditor-other-menu-inactive',
    hasMandatoryAttachments: 'onb-partnereditor-other-has-mandatory-attachments',
    mandatoryAttachmentsHelp: 'onb-partnereditor-other-mandatory-attachments-help',
  },
}
